import { ToggleVisibilityAction, getBoolValue, setProperty } from 'adaptivecards';
import ElementDetails from '../store/schema/ElementDetails';
import { TOGGLE_VISIBILITY_ACTION_CLICKED } from '../constants';

export default class CustomToggleVisibilityAction extends ToggleVisibilityAction {
    constructor(
        private logTelemetryForAction?: (
            actionEventName: string,
            elementDetails: ElementDetails
        ) => void
    ) {
        super();
    }

    public parse(json: any): void {
        super.parse(json);

        this.isPrimary = json.isPrimary;
        this.targetElements = {};

        const jsonTargetElements = json.targetElements;
        if (jsonTargetElements) {
            for (const item of jsonTargetElements) {
                if (typeof item === 'string') {
                    this.targetElements[item] = undefined;
                } else if (typeof item === 'object') {
                    const jsonElementId = item.elementId;

                    if (jsonElementId && typeof jsonElementId === 'string') {
                        this.targetElements[jsonElementId] = getBoolValue(
                            item.isVisible,
                            undefined
                        );
                    }
                }
            }
        }
    }

    public toJSON(): any {
        let result = super.toJSON();
        setProperty(result, 'isPrimary', this.isPrimary, false);
        return result;
    }

    public execute() {
        if (this.logTelemetryForAction) {
            const elementDetails: ElementDetails = {
                id: this.id,
                type: this.getJsonTypeName(),
            };
            this.logTelemetryForAction(TOGGLE_VISIBILITY_ACTION_CLICKED, elementDetails);
        }
        super.execute();
    }
}
